interface ApiCallback<T> {
  success: (res: T) => void;
  fail?: (err: any) => void;
}

interface MultiDataCenterConfig {
  domain: {
    domainUrl: string
  }
  tenantDomain: string;
  currentTenantID: string
}

interface UserYHTInfo {

  tenant_id: string;
  a00: string;
  tenant_name: string;
  yht_userid: string;
  yhtToken: string;
  userName: string;

}

interface ApiInterface {
  gainUserInfo: (callback: ApiCallback<UserInfo>) => void;
  getMultiDataCenterConfig: (callback: ApiCallback<MultiDataCenterConfig>) => void;
  getUserYHTInfo: (callback: ApiCallback<UserYHTInfo>) => void;
  addEventListener: (params: { name: string }, callback: (ret: any) => void) => void;
}

declare const api: ApiInterface

interface UserInfo {
  deptName: string;
  mobile: string;
  deptID: string;
  isAdmin: string;
  avatar: string;
  accessToken?: string;
  userId?: string;
  muid: string;
  qzId: string;
  loginName: string;
  name: string;
  qzName: string;
  email: string;
}

export async function getCurrentUserInfo(): Promise<UserInfo> {
  return new Promise((resolve, reject) => {
    api.gainUserInfo({
      success: (ret: UserInfo) => {
        // 这俩是错的，不要用
        delete ret.accessToken
        delete ret.userId
        resolve(ret)
      },
      fail: (err: any) => {
        reject(err)
      }
    })
  })
}

export async function getHost(): Promise<MultiDataCenterConfig> {
  return new Promise((resolve, reject) => {
    api.getMultiDataCenterConfig({
      success: resolve,
      fail: (err: any) => {
        reject(err)
      }
    })
  })
}

interface YhtInfo {
  yhtAccessToken: string;
  userId: string
}

export async function getYhtToken(): Promise<YhtInfo> {
  return new Promise((resolve) => {
    api.getUserYHTInfo({
      // @ts-expect-error 先这样
      isEncrypt: false,
      success: (res: UserYHTInfo) => {
        resolve({
          yhtAccessToken: res.yhtToken,
          userId: res.yht_userid
        })
      }
    })
  })
}

export enum Env {
  DAILY = 'daily',
  TEST = 'test',
  PROD = 'prod',
  PRE = 'pre',
  OTHER = 'other'
}

export async function getEnv(host: string): Promise<Env> {
  // 直接查找匹配的环境，PROD 作为默认值
  return (Object.values(Env)
    .find(env => env !== Env.PROD && host.includes(env)) ?? Env.PROD) as Env
}

export async function getCurrentEnv(): Promise<Env> {
  const host = await getHost()
  return getEnv(host.tenantDomain||'other')
}

interface BaseInfo {
  ymsHost: string
  host: string;
  env: Env;
  userInfo: UserInfo;
  yhtAccessToken: string;
  name: string;
  currentTenantID:string
}


export async function getCurrentBaseInfo(): Promise<BaseInfo> {
  const {
    currentTenantID,
    domain: {
      domainUrl: host
    },
    tenantDomain: ymsHost=host
  } = await getHost()
  const env = await getCurrentEnv()
  const userInfo = await getCurrentUserInfo()
  const { yhtAccessToken, userId } = await getYhtToken()
  userInfo.userId = userId
  return { host, ymsHost, env, userInfo, yhtAccessToken, name: userInfo.qzName, currentTenantID }
}

// 添加租户数据
const TENANTS = {
  prod: [
    {id: 'prod1', name: '租户1'},
    {id: 'prod2', name: '租户2'},
    {id: 'prod3', name: '租户3'}
  ],
  daily: [
    {id: 'daily1', name: '租户1'},
    {id: 'daily2', name: '租户2'},
    {id: 'daily3', name: '租户3'}
  ],
  test: [
    {id: 'test1', name: '租户1'},
    {id: 'test2', name: '租户2'},
    {id: 'test3', name: '租户3'}
  ]
}

let isMobile = false
const roomId = window.location.pathname.slice(1) || 'public'
const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
const ws = new WebSocket(`${protocol}//${window.location.host}/ws/${roomId}`)

// DOM 元素
const messagesDiv = document.getElementById('messages') as HTMLDivElement
const messageInput = document.getElementById('message-input') as HTMLInputElement
const usersDiv = document.getElementById('users-list') as HTMLDivElement
const userCountSpan = document.getElementById('user-count') as HTMLSpanElement
const roomIdSpan = document.getElementById('room-id') as HTMLSpanElement
const buildHash = document.getElementById('build-hash') as HTMLSpanElement

roomIdSpan.textContent = roomId
// @ts-expect-error 这里会通过 esbuild 替换成实际的值
buildHash.textContent = __BUILD_HASH__

function formatUserAgent(ua: string, type: string) {
  if (type === 'developer') {
    return '🖥️ 开发工具端'
  } else {
    return '📱 移动设备'
  }
}

function sendMessage() {
  const message = messageInput.value
  if (message.trim() && ws.readyState === WebSocket.OPEN) {
    ws.send(message)
    messageInput.value = ''
    messageInput.focus()
  }
}

function renderAccountCards() {
  const accounts = JSON.parse(localStorage.getItem('accounts') || '[]')
  const dailyAccounts = document.getElementById('dailyAccounts') as HTMLDivElement
  const testAccounts = document.getElementById('testAccounts') as HTMLDivElement
  const currentAccount = document.getElementById('currentAccount') as HTMLDivElement

  const daily = accounts.filter((acc: any) => acc.env === 'daily')
  const test = accounts.filter((acc: any) => acc.env === 'test')
  const hasSelectedAccount = accounts.some((acc: any) => acc.selected)

  function renderAccountCard(acc: any) {
    const tenants = TENANTS[acc.env as keyof typeof TENANTS]
    return `
      <div class="account-card ${acc.expanded ? 'expanded' : ''} ${acc.selected ? 'selected' : ''}" 
           onclick="toggleTenants('${acc.phone}', '${acc.env}')">
        <div class="account-header">
          <div class="account-info">
            <div class="account-phone">${acc.phone}</div>
            <div class="tenant-name">${acc.selectedTenant?.name || '请选择租户'}</div>
          </div>
          <span class="expand-icon">▼</span>
        </div>
        <div class="tenants-list">
          ${tenants.map(tenant => `
            <div class="tenant-item ${tenant.id === acc.selectedTenant?.id ? 'selected' : ''}"
                 onclick="event.stopPropagation(); selectTenant('${acc.phone}', '${acc.env}', '${tenant.id}')">
              ${tenant.name}
            </div>
          `).join('')}
        </div>
      </div>
    `
  }

  dailyAccounts.innerHTML = daily.length ? daily.map(renderAccountCard).join('')
    : '<div class="no-accounts">暂无账号</div>'

  testAccounts.innerHTML = test.length ? test.map(renderAccountCard).join('')
    : '<div class="no-accounts">暂无账号</div>'

  // 渲染当前环境账号
  getCurrentBaseInfo().then(baseInfo => {
    currentAccount.innerHTML = `
      <div class="account-card current-card ${!hasSelectedAccount ? 'selected' : ''}" 
           onclick="selectCurrentAccount()">
        <div class="account-header">
          <div class="account-info">
            <div class="account-phone">${baseInfo.userInfo.mobile}</div>
            <div class="tenant-name">${baseInfo.userInfo.qzName || '当前租户'}</div>
          </div>
        </div>
      </div>
    `
    updateSendButton()
  }).catch(error => {
    console.error('获取当前环境信息失败:', error)
    currentAccount.innerHTML = '<div class="no-accounts">获取当前账号失败</div>'
  })

  const dailyAccountsGroup = document.querySelector('.daily-accounts') as HTMLElement
  const testAccountsGroup = document.querySelector('.test-accounts') as HTMLElement
  dailyAccountsGroup.style.display = daily.length ? 'block' : 'none'
  testAccountsGroup.style.display = test.length ? 'block' : 'none'
}

function updateSendButton() {
  const selectedCard = document.querySelector('.account-card.selected')
  const sendButton = document.querySelector('.send-info-btn') as HTMLButtonElement

  if (selectedCard) {
    const phone = selectedCard.querySelector('.account-phone')?.textContent
    const isCurrent = selectedCard.classList.contains('current-card')
    const env = isCurrent ? '当前环境' :
      selectedCard.querySelector('.tenant-name')?.textContent?.includes('日常') ? '日常环境' : '测试环境'
    const tenant = isCurrent ? '当前租户' :
      selectedCard.querySelector('.tenant-name')?.textContent

    sendButton.innerHTML = `
      发送当前开发信息
      <span class="send-info-text">${phone} | ${env} | ${tenant}</span>
    `
  } else {
    sendButton.innerHTML = '发送当前开发信息'
  }
}

function refreshPage() {
  window.location.reload()
}

function toggleTenants(phone: string, env: string) {
  const accounts = JSON.parse(localStorage.getItem('accounts') || '[]')
  const account = accounts.find((acc: any) => acc.phone === phone && acc.env === env)
  if (account) {
    account.expanded = !account.expanded
    localStorage.setItem('accounts', JSON.stringify(accounts))
    renderAccountCards()
  }
}

function selectTenant(phone: string, env: string, tenantId: string) {
  const accounts = JSON.parse(localStorage.getItem('accounts') || '[]')
  const account = accounts.find((acc: any) => acc.phone === phone && acc.env === env)
  if (account) {
    const tenant = TENANTS[env as keyof typeof TENANTS].find(t => t.id === tenantId)
    if (tenant) {
      accounts.forEach((acc: any) => acc.selected = false)
      const prodCard = document.querySelector('.prod-card')
      if (prodCard) {
        prodCard.classList.remove('selected')
      }

      account.selectedTenant = tenant
      account.expanded = false
      account.selected = true
      localStorage.setItem('accounts', JSON.stringify(accounts))
      renderAccountCards()
      updateSendButton()
    }
  }
}

function selectCurrentAccount() {
  const accounts = JSON.parse(localStorage.getItem('accounts') || '[]')
  accounts.forEach((acc: any) => acc.selected = false)
  localStorage.setItem('accounts', JSON.stringify(accounts))

  // 移除其他卡片的选中状态
  document.querySelectorAll('.account-card').forEach(card => {
    card.classList.remove('selected')
  })

  // 添加当前环境卡片的选中状态
  const currentCard = document.querySelector('.current-card')
  if (currentCard) {
    currentCard.classList.add('selected')
  }

  updateSendButton()
}

function openAccountManager() {
  if (window.api && (window.api as any).openTabLayout) {
    (window.api as any).openTabLayout({
      name: 'accountManager',
      url: '/account.html',
      title: '账号管理',
      hideNavigationBar: false,
      navigationBar: {}
    })
  } else {
    window.location.href = '/account.html'
  }
}

// 事件监听器设置
document.addEventListener('DOMContentLoaded', () => {
  if (!isMobile) {
    document.body.classList.add('developer')

    // 动态加载 qrcode.js
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/qrcodejs@1.0.0/qrcode.min.js'
    script.onload = () => {
      // 创建二维码
      const qrcodeElement = document.getElementById('qrcode')
      if (qrcodeElement) {
        new (window as any).QRCode(qrcodeElement, {
          text: window.location.href,
          width: 168,
          height: 168,
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: (window as any).QRCode.CorrectLevel.L
        })
      }
    }
    document.head.appendChild(script)
  }

  messageInput?.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      sendMessage()
    }
  })
})

document.addEventListener('apiready', () => {
  isMobile = true
  document.body.classList.remove('developer')
  document.body.classList.add('provider')

  renderAccountCards()
  updateSendButton()


  api.addEventListener({
    name: 'viewappear'
  }, () => {
    renderAccountCards()
    updateSendButton()
  })

})

// WebSocket 消息处理
ws.onmessage = (event) => {
  const data = JSON.parse(event.data)

  if (data.type === 'users') {
    updateUsersList(data.data)
  } else if (data.type === 'message' && !isMobile) {
    const messageElement = document.createElement('div')
    messageElement.className = 'message'

    const userElement = document.createElement('div')
    userElement.className = `message-user ${data.clientType}`
    userElement.textContent = formatUserAgent(data.userAgent, data.clientType)

    const textElement = document.createElement('div')
    textElement.className = 'message-text'
    try {
      const jsonData = JSON.parse(data.data)
      textElement.textContent = JSON.stringify(jsonData, null, 2)
    } catch {
      textElement.textContent = data.data
    }

    messageElement.appendChild(userElement)
    messageElement.appendChild(textElement)
    messagesDiv.appendChild(messageElement)
    messagesDiv.scrollTop = messagesDiv.scrollHeight
  }
}

async function sendDeviceInfo() {
  if (isMobile) {
    const selectedCard = document.querySelector('.account-card.selected')
    if (!selectedCard) {
      alert('请先选择一个账号')
      return
    }

    try {
      const info = await getCurrentBaseInfo()

      const sendInfo = {
        ...info,
        userInfo: {
          ...info.userInfo,
          tenantName: info.userInfo.qzName,
          tenantId: info.currentTenantID,
          memberId: info.userInfo.muid,
          userId: info.userInfo.userId,
          avatar: info.userInfo.avatar,
          host: info.host,
          ymsHost: info.ymsHost||info.host,
          yhtAccessToken: info.yhtAccessToken
        }
      }

      if (!info.userInfo.qzName) {
        alert('请先选择租户')
        return
      }
      ws.send(JSON.stringify({
        channel: 'base-info',
        body: sendInfo
      }))
    } catch (error) {
      console.error('获取设备信息失败:', error)
      alert('获取设备信息失败，请重试')
    }
  }
}

// 将所有函数添加到 window 对象上，使其在 HTML 中可用
declare global {
  interface Window {
    sendMessage: typeof sendMessage;
    refreshPage: typeof refreshPage;
    openAccountManager: typeof openAccountManager;
    toggleTenants: typeof toggleTenants;
    selectTenant: typeof selectTenant;
    selectCurrentAccount: typeof selectCurrentAccount;
    sendDeviceInfo: typeof sendDeviceInfo;
    api: {
      systemType: string;
      winWidth: number;
      winHeight: number;
      openTabLayout: (config: {
        name: string;
        url: string;
        title?: string;
        hideNavigationBar?: boolean;
        navigationBar?: {
          background: string;
          color: string;
          leftButtons: Array<{
            iconPath: string;
          }>;
        };
        animation: {
          type: string;
          subType: string;
        };
      }) => void;
    };
    QRCode: any;
  }
}

Object.assign(window, {
  sendMessage,
  refreshPage,
  openAccountManager,
  toggleTenants,
  selectTenant,
  selectCurrentAccount,
  sendDeviceInfo
})

function updateUsersList(users: any[]) {
  const usersList = document.getElementById('users-list')!
  const userCount = document.getElementById('user-count')!
  usersList.innerHTML = ''

  // 过滤掉默认的开发工具端（游客）
  const filteredUsers = users.filter(user => {
    if (user.type === 'developer') {
      return !(user.userAgent === 'Unknown Client' || user.userAgent.includes('Mozilla'))
    }
    return true
  })

  userCount.textContent = filteredUsers.length.toString()

  filteredUsers.forEach(user => {
    const userElement = document.createElement('div')
    userElement.className = `user-item ${user.type}`

    let displayName
    if (user.type === 'developer') {
      displayName = `🖥️ ${user.userAgent}`
    } else {
      // 解析移动端 UA
      const ua = user.userAgent
      const parts = ua.split(' ')

      // 解析友空间版本信息
      const qyzoneInfo = parts.find((p: string) => p.startsWith('QYZone_'))
      let platform = ''
      let version = ''
      let env = ''

      if (qyzoneInfo) {
        // QYZone_1-6.2.7-1-1 格式解析
        const [_, info] = qyzoneInfo.split('QYZone_')  // 先分离 QYZone_ 前缀
        const [deviceType, appVersion, envType] = info.split('-')  // 按 - 分割各部分
        platform = deviceType === '1' ? 'Android' : 'iOS'  // 1 是 Android，2 是 iOS
        version = appVersion
        env = envType === '1' ? '正式版' : '测试版'
        displayName = `📱 QYZone ${env} (v${version}) - ${platform}`
      } else {
        platform = ua.includes('iPhone') ? 'iOS' : 'Android'
        displayName = `📱 ${platform}`
      }
    }

    userElement.textContent = displayName
    usersList.appendChild(userElement)
  })
}
